import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum PriorityIds {
  CRITICAL = 1,
  HIGH = 2,
  MEDIUM = 3,
  LOW = 4,
}

export function getPriorities(): ISelectItem[] {
  return [
    { id: PriorityIds.CRITICAL, label: 'Critical' },
    { id: PriorityIds.HIGH, label: 'High' },
    { id: PriorityIds.MEDIUM, label: 'Medium' },
    { id: PriorityIds.LOW, label: 'Low' },
  ]
}

export const getPriorityByLabel = getItemByLabelFactory(getPriorities)
export const getPriorityById = getItemByIdFactory(getPriorities)
